import { NavLink } from "react-router-dom";
import pic from "Assets/Images/MediaDaapApp/blog2.png";

import "./style.css";
import Logo from "Assets/Images/Logo/logoRes.png";
import { ArrowLeft, ArrowRight, Tags } from "react-bootstrap-icons";
import ShowComment from "CommonComponents/ShowComment/ShowComment";
import AddComment from "CommonComponents/AddComment";
import SuggestBlog from "CommonComponents/SuggestBlog";

const MainSingleBlog = ({ singleBlog }) => {
  const { caption, comments, tags, related, next, previous, id } = singleBlog;
  
  return (
    <div className="container">
      <div className="content-single-post pt-3">
        <p className=" caption-line">{caption}</p>
      </div>
      <div className="post-content-details border-bottom d-flex justify-content-between align-items-center py-3">
        <div className="writer-details d-flex justify-content-between align-items-center  ">
          <div className=" bg-white rounded-circle p-2 ">
            <img src={Logo} alt="" className=" rounded-circle" />
          </div>
          <p className="m-0 me-2">تیم نویسندگان داپ اَپ</p>
        </div>
        <ul className="tag-name-box d-flex justify-content-between b p-0 m-0">
          {Array.isArray(tags)
            ? tags.length > 0
              ? tags.map((tag) => {
                  return (
                    <li className="border-start  d-flex justify-content-centera align-items-center main-color px-2">
                      {tag}
                    </li>
                  );
                })
              : null
            : null}

          <Tags size={38} className="pe-3" />
        </ul>
      </div>
      <div className="next-previous-post  d-flex justify-content-between align-items-center py-3">
        {next == null ? (
          <div> </div>
        ) : (
          <NavLink
            to={`/blog/${next.id}`}
            className="text-dap-success text-center"
          >
            <ArrowRight
              color="#00a78d"
              className="ps-2 text-center "
              size={30}
            />
            {next.subject}
          </NavLink>
        )}

        {previous == null ? (
          <div> </div>
        ) : (
          <NavLink to={`/blog/${previous.id}`} className="text-dap-success">
            {previous.subject}

            <ArrowLeft color="#00a78d" className="pe-2" size={30} />
          </NavLink>
        )}
      </div>
      {/* add  comment*/}

      <AddComment id={id} />
      {/* comment */}
      <div className="all-comment-box  d-flex justify-content-center align-items-center flex-column my-4">
        <h6 className="mb-4">نظرات</h6>
        {Array.isArray(comments) ? (
          comments.length > 0 ? (
            comments.map((eachComment) => {
              return (
                <ShowComment eachComment={eachComment} key={eachComment.id} />
              );
            })
          ) : (
            <p className=" bg-shiri w-100 text-center p-3">نظری ثبت نشده است</p>
          )
        ) : null}
      </div>
      {/* daap app post */}
      {Array.isArray(related) && related.length > 0 ? (
        <div className="read-more-media d-flex justify-content-center flex-column  ">
          <h6 className="border-bottom text-center pb-4 ">
            در رسانه داپ‌اَپ بیشتر بخوانید
          </h6>

          <SuggestBlog related={related} />
        </div>
      ) : null}
    </div>
  );
};

export default MainSingleBlog;
//   to={`/blog/${next.id}`}
